import React from "react";
import ConnectingButton from "./ConnectingButton";
import { useHistory } from "react-router-dom";

const ConnectingButtons = ({ setIsRoomHostAction }) => {
  let history = useHistory();

  const pushToJoinRoomPage = () => {
    setIsRoomHostAction(false);
    history.push("/join-room?host=false");
  };

  const pushToJoinRoomPageAsHost = () => {
    setIsRoomHostAction(true);
    history.push("/join-room?host=true");
  };

  return (
    <div className="connecting_buttons_container">
      <ConnectingButton
        buttonText="Join a meeting"
        onClickHandler={pushToJoinRoomPage}
      />
      <ConnectingButton
        createRoomButton
        buttonText="Host a meeting"
        onClickHandler={pushToJoinRoomPageAsHost}
      />
    </div>
  );
};

export default ConnectingButtons;
